

export const OAUTH_GROUP_LINKS = {
	BASE: "/app/oauth",
	ETSY: "/app/oauth/etsy",
	EBAY: "/app/oauth/ebay",
};
